import { Fragment, useLayoutEffect, useRef, useState } from "react";

// Mount only with real positive dimensions; reset stale chart/tooltip coordinates on resize.
export const MeasuredChart = ({ height, children, testId }) => {
  const container = useRef(null);
  const [width, setWidth] = useState(0);
  useLayoutEffect(() => {
    const node = container.current;
    const update = () => setWidth(Math.max(0, Math.floor(node.clientWidth)));
    update();
    const observer = new ResizeObserver(update);
    observer.observe(node);
    return () => observer.disconnect();
  }, []);
  return <div ref={container} className="w-full min-w-0" style={{ height, contain: "inline-size" }} data-testid={testId}>
    {width > 0 && <Fragment key={width}>{children(width, height)}</Fragment>}
  </div>;
};

export const chartTooltipProps = {
  position: { x: 0, y: 0 },
  wrapperStyle: { maxWidth: "100%", zIndex: 10 },
  contentStyle: { whiteSpace: "normal", overflowWrap: "anywhere", maxWidth: "100%", fontSize: 12 },
};